<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>
    <tt-list-legacy class="col-xs-12 col-md-4 sp-0" [listItems]="itemsListDispatches" ltype="custom" [optionfunc]="openWebLinkDispatch.bind(this)"></tt-list-legacy>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <div ng-if="vm.model.setting.page_heading > ''">
        <tt-header tt-model="vm.model.setting.page_heading"></tt-header>
    </div>

    <im-list-directive class="col-xs-12 col-md-4 sp-0" list-items="vm.model.itemsListDispatches" badge="" ltype="custom" design-var="s12t0" optionfunc="vm.openWebLinkDispatch(item)"></im-list-directive>
</tt-page>-->
